export default __webpack_public_path__ + "static/media/takePicture.ba2b138f.png";